import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import RxStructureService from '@Services/RxStructureService';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { LinkElement } from '@els/els-react--link-element';
import find from 'lodash/find';
import { FEATURES } from '@Constants/rx-ui/constants';
import NumberFormatter from '@Utils/NumberFormatter.js';
import { Badge } from '@els/els-react--badge';

import './CommercialSubstancesProviderListItem.scss';

function CommercialSubstancesProviderListItem({ structure, closeMenu, onClick = () => null }) {
  const openInDatabase = (db) => {
    RxStructureService.openInDatabase(db, getValueByNs(structure, 'metadata.originalSearchType'));
    closeMenu && closeMenu();
  };

  const commercialSubstances = find(getValueByNs(structure, 'subLinks', []), { databaseId: '20' });

  if (!commercialSubstances) return null;

  return (
    <li role="menuitem" className="u-els-display-flex commercial-substances-item u-els-margin-bottom-1o2">
      <LinkElement
        className="provider-link e2e-shopping-cart-commercial-substances u-els-padding-right-1o2"
        href="#"
        iconSize="xs"
        iconSprite="ChevronRight"
        data-e2e="shopping-cart-commercial-substances"
        onClick={(e) => {
          e.preventDefault();
          onClick();
          openInDatabase(commercialSubstances);
        }}>
        Commercial Suppliers
      </LinkElement>
      <span className="column-provider-logo shopping-cart-block">
        {Auth.isFeatureEnabled(FEATURES.enableDisplaySupplierNumber) && !!structure.supplierNumber && (
          <Badge
            type="subtle"
            className="shopping-cart-badge"
            label="Number of suppliers"
            content={NumberFormatter(structure.supplierNumber)}
          />
        )}
      </span>
    </li>
  );
}

CommercialSubstancesProviderListItem.propTypes = {
  structure: PropTypes.object.isRequired,
  closeMenu: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default CommercialSubstancesProviderListItem;
